import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GET_USER_DATA: ({ commit, dispatch }, to) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/info`).then(res => {
        commit('SET_USER', res.body)
        commit('SET_ROLE', res.body.role)
        commit('UPDATE_TOTALS_FROM_USER', res.body)
        if (res.body.role === 'admin') dispatch('GET_COUNTS')
        dispatch('GET_USER_COUNTRY')
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  USERS: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/datatable`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_USER: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/export`, { user_id: userId }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EXPORT_USERS: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/export-many`, {}, {
        responseType: 'arraybuffer',
        headers: {'Accept': 'application/octet-stream'}
      }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  DELETE_USERS: ({ commit, dispatch }, {userIds, block}) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/delete`, { user_ids: userIds, block: block }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ACTIVATE_USER: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/${userId}`, { action: 'alternative_activate' }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  RESET_USER_PERMISSIONS: ({ commit, dispatch }, userId) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/${userId}`, { action: 'remove_overridden_permissions' }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  INVITE_USER: ({ commit, dispatch }, email) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/invite`, { email: email }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  EDIT_USER: ({ commit, dispatch }, {userId, newData}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/users/${userId}`, newData).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  REGISTERD_USERS_CHART: ({ commit, dispatch }, to) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/registrations-chart`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  ACTIVE_USERS_CHART: ({ commit, dispatch }, to) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/dashboard/active-users-chart`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SEND_OFFER: ({ commit, dispatch }, offer) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/utils/user-offer`, offer,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      ).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  CHANGE_USER_PASSWORD: ({ commit, dispatch }, {oldPassword, newPassword}) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/users/password`, {old_password: oldPassword, new_password: newPassword}).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  FIRST_DAY_OF_WEEK: ({ commit, dispatch }, firstDay) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/users/first-day`, {first_day: firstDay}).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_USER_COUNTRY: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get('https://ipinfo.io').then(res => {
        // if (res.body.country === 'IL') {
        //   commit('SET_CURRENCY', 'NIS')
        // } else {
        //   commit('SET_CURRENCY', 'USD')
        // }
        commit('SET_IP_DATA', res.body)
        resolve()
      }, err => {
        reject(err)
      })
    })
  },
  SET_USER_CURRENCY: ({ commit, dispatch }, currency) => {
    return new Promise((resolve, reject) => {
      Vue.http.put(`${apiUrl}${version}/users/currency`, { currency: currency }).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  GET_CURRENCY_RATE: ({ commit, dispatch }) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/payments/currency-rate`).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  SET_CURRENCY_RATE: ({ commit, dispatch }, currencyRate) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/payments/currency-rate`, {currency_rate: currencyRate}).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  },
  // email=['email': str],
  // password=['password': str],
  // status=('status', ky.enums.UserStatus.PhoneOnlyVerified.value, int),
  // fullname=('fullname', None, str),
  // phone_number=('phone_number', None, str),
  // country_code=('country_code', None, str),
  // work_in=('work_in', None, str),
  ADD_USER: ({ commit, dispatch }, params) => {
    return new Promise((resolve, reject) => {
      Vue.http.post(`${apiUrl}${version}/users/create`, params).then(res => {
        resolve(res.body)
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions.js